import React from 'react';
import Card from './Card';
import Lightblue from '../../assets/img/lightblue.jpg';
import Bronze from '../../assets/img/bronze.jpg';
import Silver from '../../assets/img/silver.jpg';
import Gold from '../../assets/img/gold.jpg';
import purple1 from '../../assets/img/purple1.jpg';
import purple2 from '../../assets/img/purple2.jpg';
import { useLanguage } from '../../LanguageContext'; // Adjust the import path as needed

import './Pack.scss';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function Pack() {
  const { language } = useLanguage();
  return (
    <div id="app" className="container">
      {/* <Card dataImage={Lightblue}>
        <h1 slot="header" className={language === 'es' ? 'header-spanish' : ''}>
          <TranslateText text="Starter Package" />
        </h1>
        <p slot="content"><TranslateText text="$1,499" /></p>
        <span><TranslateText text="2 TRADELINES " /></span>
        <span><TranslateText text="(1 SMALL + 1 MEDIUM)" /></span>
      </Card> */}

      <Card dataImage={Bronze}>
        <h1 slot="header" className={language === 'es' ? 'header-spanish' : ''}>
          <TranslateText text="Bronze Package" />
        </h1>
        <p slot="content"><TranslateText text="$1,999" /></p>
        <span><TranslateText text="2 TRADELINES " /></span>
        <span><TranslateText text="( 1 MEDIUM + 1 Large)" /></span>
      </Card>

      <Card dataImage={Silver}>
        <h1 slot="header" className={language === 'es' ? 'header-spanish' : ''}>
          <TranslateText text="Silver Package" />
        </h1>
        <p slot="content"><TranslateText text="$2,499" /></p>
        <span><TranslateText text="3 TRADELINES " /></span>
        <span><TranslateText text="(2 MEDIUM + 1 LARGE)" /></span>
      </Card>

      <Card dataImage={Gold}>
        <h1 slot="header" className={language === 'es' ? 'header-spanish' : ''}>
          <TranslateText text="Gold Package" />
        </h1>
        <p slot="content"><TranslateText text="$2,999" /></p>
        <span><TranslateText text="3 TRADELINES " /></span>
        <span><TranslateText text="(1 MEDIUM + 1 large + 1-X Large)" /></span>
      </Card>

      <Card dataImage={purple1}>
        <h1 slot="header" className={language === 'es' ? 'header-spanish' : ''}>
          <TranslateText text="HOLIDAY SPECIAL " />
        </h1>
        <p slot="content"><TranslateText text="$2,499" /></p>
        <span><TranslateText text="HOLIDAY SPECIAL Elite Credit Repair Deluxe + Inquiry Removal + 1-X Large Aged Tradeline Combo" /></span>
      </Card>
      
      {/* <Card dataImage={purple2}>
        <h1 slot="header" className={language === 'es' ? 'header-spanish' : ''}>
          <TranslateText text="HOLIDAY SPECIAL #2" />
        </h1>
        <p slot="content"><TranslateText text="$2,249" /></p>
        <span><TranslateText text="HOLIDAY SPECIAL Elite Credit Repair Deluxe + Inquiry Removal + 1-X Large Aged Tradeline Combo" /></span>
      </Card> */}
    </div>
  );
}

export default Pack;







// import React from 'react';
// import Card from './Card';
// import Lightblue from '../../assets/img/lightblue.jpg';
// import Bronze from '../../assets/img/bronze.jpg';
// import Silver from '../../assets/img/silver.jpg';
// import Gold from '../../assets/img/gold.jpg';
// import purple1 from '../../assets/img/purple1.jpg';
// import purple2 from '../../assets/img/purple2.jpg';
// import { useLanguage } from '../../LanguageContext'; // Adjust the import path as needed


// import './Pack.scss';
// import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

// function Pack() {
//   const { language } = useLanguage();
//   return (

    
//     <div id="app" className="container">
//       <Card dataImage={Lightblue}>
//         <h1 slot="header"><TranslateText text="Starter Package" /></h1>
//         <p slot="content"><TranslateText text="$1,499" /></p>
//         <span><TranslateText text="2 TRADELINES " /></span>
//         <span><TranslateText text="(1 SMALL + 1 MEDIUM)" /></span>
//       </Card>

//       <Card dataImage={Bronze}>
//         <h1 slot="header"><TranslateText text="Bronze Package" /></h1>
//         <p slot="content"><TranslateText text="$1,999" /></p>
//         <span><TranslateText text="3 TRADELINES " /></span>
//         <span><TranslateText text="(1 SMALL + 1 MEDIUM + 1 Large)" /></span>
//       </Card>


//       <Card dataImage={Silver}>
//         <h1 slot="header"><TranslateText text="Silver Package" /></h1>
//         <p slot="content"><TranslateText text="$2,499" /></p>
//         <span><TranslateText text="3 TRADELINES " /></span>
//         <span><TranslateText text="(1 MEDIUM + 1 LARGE)" /></span>
//       </Card>

//       <Card dataImage={Gold}>
//         <h1 slot="header"><TranslateText text="Gold Package" /></h1>
//         <p slot="content"><TranslateText text="$2,999" /></p>
//         <span><TranslateText text="3 TRADELINES " /></span>
//         <span><TranslateText text="(1 MEDIUM + 1 large + 1-X Large)" /></span>
//       </Card>


//       <Card dataImage={purple1}>
//         <div className={language === 'es' ? 'spanish-pack' : ''}><h1 slot="header"><TranslateText text="HOLIDAY SPECIAL #1" /></h1></div>
//         <p slot="content"><TranslateText text="$1,999" /></p>
//         <span><TranslateText text="HOLIDAY SPECIAL Elite Credit Repair Deluxe + Inquiry Removal + 1 Large Aged Tradeline Combo" /></span>
//       </Card>
      
      
//       <Card dataImage={purple2}>
//         <h1 slot="header"><TranslateText text="HOLIDAY SPECIAL #2" /></h1>
//         <p slot="content"><TranslateText text="$2,249" /></p>
//         <span><TranslateText text="HOLIDAY SPECIAL Elite Credit Repair Deluxe + Inquiry Removal + 1-X Large Aged Tradeline Combo" /></span>
//       </Card>
//     </div>
//   );
  
// }

// export default Pack;





// // import React from 'react';
// // import Card from './Card';
// // import Lightblue from '../../assets/img/lightblue.jpg'
// // import Bronze from '../../assets/img/bronze.jpg'
// // import Silver from '../../assets/img/silver.jpg'
// // import Gold from '../../assets/img/gold.jpg'
// // import purple1 from '../../assets/img/purple1.jpg'
// // import purple2 from '../../assets/img/purple2.jpg'
// // import './Pack.scss'
// // function Pack() {
// //   return (
// //     <div id="app" className="container">
// //      <Card dataImage={Lightblue}>
// //         <h1 slot="header">Starter Package</h1>
// //         <p slot="content">$1,499</p>
// //         <span>2 TRADELINES </span>
// //         <span>(1 SMALL + 1 MEDIUM )</span>

// //       </Card>
// //       <Card dataImage={Bronze}>
// //         <h1 slot="header">Bronze Package</h1>
// //         <p slot="content">$1,999</p>
// //         <span>3 TRADELINES </span>
// //         <span>(1 SMALL + 1 MEDIUM + 1 Large)</span>
// //       </Card>
// //       <Card dataImage={Silver}>
// //         <h1 slot="header">Silver Package</h1>
// //         <p slot="content">$2,499</p>
// //         <span>3 TRADELINES </span>
// //         <span>(1 MEDIUM + 1 LARGE)</span>
// //       </Card>
// //       <Card dataImage={Gold}>
// //         <h1 slot="header">Gold Package</h1>
// //         <p slot="content">$2,999</p>
// //         <span>3 TRADELINES </span>
// //         <span>(1 MEDIUM + 1 large + 1-X Large)</span>
// //       </Card>
// //       <Card dataImage={purple1}>
// //         <h1 slot="header">HOLIDAY SPECIAL #1</h1>
// //         <p slot="content">$1,999</p>
// //         <span>HOLIDAY SPECIAL Elite Credit Repair Deluxe + Inquiry Removal + 1 Large Aged Tradeline Combo</span>
// //       </Card>
// //       <Card dataImage={purple2}>
// //       <h1 slot="header">HOLIDAY SPECIAL #2</h1>

// //       <p slot="content">$2,249</p>
// //         <span>HOLIDAY SPECIAL Elite Credit Repair Deluxe + Inquiry Removal + 1-X Large Aged Tradeline Combo</span>

// //       </Card>
// //     </div>
    
// //   );
// // }



// // export default Pack;
